var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCartDarker20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7ED7FB23-769B-46A3-B20A-9F410DBB0C26_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Grouped",
    transform: "translate(-962.000000, -102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(566.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-Copy",
    transform: "translate(396.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Cart_Darker_20px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7234043,14.2173913 L8.17021277,14.2173913 C6.5106383,14.2173913 5.10638298,13 4.80851064,11.3478261 L2.76595745,0 L0,0",
    id: "Stroke-1",
    stroke: "#DD9C00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40425532,3.47826087 L20,3.47826087 L19.9787234,6.52173913 C19.5957447,8.43478261 17.9787234,9.82608696 16.106383,9.95652174 L4.89361702,10.6086957",
    id: "Stroke-3",
    stroke: "#DD9C00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08510638,18.4782609 C8.08510638,19.3186957 7.41829787,20 6.59574468,20 C5.77319149,20 5.10638298,19.3186957 5.10638298,18.4782609 C5.10638298,17.6378261 5.77319149,16.9565217 6.59574468,16.9565217 C7.41829787,16.9565217 8.08510638,17.6378261 8.08510638,18.4782609 Z",
    id: "Stroke-5",
    fill: "#DD9C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2978723,18.4782609 C18.2978723,19.3186957 17.6310638,20 16.8085106,20 C15.9859574,20 15.3191489,19.3186957 15.3191489,18.4782609 C15.3191489,17.6378261 15.9859574,16.9565217 16.8085106,16.9565217 C17.6310638,16.9565217 18.2978723,17.6378261 18.2978723,18.4782609 Z",
    id: "Stroke-7",
    fill: "#DD9C00"
  })))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartDarker20Px);
export default __webpack_public_path__ + "static/media/Icon_Cart_Darker_20px.4030460aaf9e76e845c9534b67da5875.svg";
export { ForwardRef as ReactComponent };